// move between content
$('.view .point').on('click', function(e){
  e.preventDefault();
  let $parent = $(this).closest('.product-explorer');
  $parent.find('.point,.point-content').removeClass('active');
  $(this).addClass('active');
  $parent.find($(this).attr('href')).addClass('active');
});

var changeView = function($el, direction){
  var $parent = $el.closest('.product-explorer');
  var activeIndex = $parent.find('.view.active').data('index');
  var nextIndex = activeIndex + 1;
  if (direction === 'previous') {
    nextIndex = activeIndex - 1;
  } 
  var $nextView = $parent.find('.view[data-index=' + nextIndex +']');

  // move to start/end of views
  if (!$nextView.length) {
    $nextView = $parent.find('.view').first();
    if (direction === 'previous') {
      $nextView = $parent.find('.view').last();
    }
  }

  // show the next view
  $parent.find('.view,.point,.point-content').removeClass('active');
  
  // activate the first item
  $nextView.addClass('active').find('.point').first().click();
};

// move between images
// .views .control .btn is the single "rotate button"
$('.views .control .btn, .product-explorer button.next').on('click', function(e){
  e.preventDefault();
  changeView($(this),'next');
});
$('.product-explorer button.previous').on('click', function(e){
  e.preventDefault();
  changeView($(this),'previous');
});